'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_BANNER_BADGES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = ServiceBanner;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _ArrowRight = require('@deliveroo/icon-set/react/ArrowRight');

var _ArrowRight2 = _interopRequireDefault(_ArrowRight);

var _Cross = require('@deliveroo/icon-set/react/Cross');

var _Cross2 = _interopRequireDefault(_Cross);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _banners = require('../../utils/banners');

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'wrapper': 'ccl-880de55429ec6f4e',
  'banner': 'ccl-1216eddb5191360d',
  'placeholder': 'ccl-810e58d372838ff7',
  'clickable': 'ccl-c831e165b676eb42',
  'row': 'ccl-f2b456ef666705f8',
  'badge': 'ccl-6d7afd0ea236d45c',
  'renderImage': 'ccl-23c085e9b18ad54b',
  'spill': 'ccl-086a843d8b5bc4d3',
  'rider': 'ccl-75a035d8ac7ac7e8',
  'alerts': 'ccl-9791e9e51536c1af',
  'download': 'ccl-ebceba17e971b7d3',
  'content': 'ccl-91778984e73a87fb',
  'buttonWrapper': 'ccl-2f961d7d253a54cc',
  'button': 'ccl-4f2fb63efbd18baa',
  'text': 'ccl-9f49829616264124'
};
var SERVICE_BANNER_BADGES = exports.SERVICE_BANNER_BADGES = ['spill', 'rider', 'alerts', 'download'];

/**
 * A banner for service and upsell purposes — should not be used for
 * Deliveroo-branded services. See also: PromoBanner, which has a nearly
 * identical implementation for promotion-related messages.
 */
function ServiceBanner(originalProps) {
  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, ServiceBanner.placeholderProps) : originalProps;
  var title = props.title,
      body = props.body,
      badge = props.badge,
      renderImage = props.renderImage,
      href = props.href,
      shouldOpenInNewWindow = props.shouldOpenInNewWindow,
      isMobileRow = props.isMobileRow,
      buttonLabel = props.buttonLabel,
      onClick = props.onClick,
      hasCloseButton = props.hasCloseButton;


  var hasButton = !!buttonLabel && onClick;
  var isClickable = !hasButton && (href || onClick);
  var iconComponent = hasCloseButton ? _Cross2.default : _ArrowRight2.default;

  var _linkOrButton = (0, _banners.linkOrButton)({ href: href, onClick: onClick, hasButton: hasButton, shouldOpenInNewWindow: shouldOpenInNewWindow }),
      _linkOrButton2 = _slicedToArray(_linkOrButton, 2),
      Element = _linkOrButton2[0],
      elementProps = _linkOrButton2[1];

  var bannerClassNames = (0, _banners.getBannerClassNames)({
    styles: styles,
    isClickable: isClickable,
    isMobileRow: isMobileRow,
    isPlaceholder: isPlaceholder
  });

  var iconColor = iconComponent === _ArrowRight2.default ? 'teal' : 'light-grey';

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'div',
      spacing: props.spacing,
      className: styles.wrapper,
      adjacentVerticalSpacing: props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing: props.adjacentHorizontalSpacing,
      isPlaceholder: isPlaceholder
    },
    _react2.default.createElement(
      Element,
      _extends({}, elementProps, { className: bannerClassNames }),
      !renderImage && badge && _react2.default.createElement('div', { className: (0, _classnames3.default)(styles.badge, styles[badge]) }),
      renderImage && _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(styles.renderImage) },
        renderImage()
      ),
      _react2.default.createElement(
        _SpacerElement2.default,
        {
          element: 'div',
          className: (0, _classnames3.default)(styles.content, _defineProperty({}, styles.button, hasButton)),
          adjacentHorizontalSpacing: 'medium'
        },
        _react2.default.createElement(
          _SpacerElement2.default,
          { className: styles.text, adjacentHorizontalSpacing: 'medium' },
          _react2.default.createElement(
            _Heading2.default,
            { level: 4, size: 'x-small' },
            title
          ),
          _react2.default.createElement(
            _P2.default,
            { size: 'small', adjacentVerticalSpacing: 'x-small' },
            body
          )
        ),
        isClickable && _react2.default.createElement(_Icon2.default, {
          component: iconComponent,
          size: 24,
          adjacentHorizontalSpacing: 'small',
          color: iconColor
        }),
        hasButton && _react2.default.createElement(
          'span',
          { className: styles.buttonWrapper },
          _react2.default.createElement(
            _Button2.default,
            {
              size: 'small',
              onClick: onClick,
              href: href,
              type: 'secondary',
              newWindow: shouldOpenInNewWindow
            },
            buttonLabel
          )
        )
      )
    )
  );
}

ServiceBanner.displayName = 'ServiceBanner';
ServiceBanner.propTypes = _extends({
  /**
   * Title text for the banner
   */
  title: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (_ref) {
    var isPlaceholder = _ref.isPlaceholder;
    return !isPlaceholder;
  }),

  /**
   * Body text of the banner
   */
  body: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (_ref2) {
    var isPlaceholder = _ref2.isPlaceholder;
    return !isPlaceholder;
  }),

  /**
   * An optional named badge icon to display inside the banner.
   */
  badge: _propTypes2.default.oneOf(SERVICE_BANNER_BADGES),

  /**
   * An optional render prop to show an arbitrary image.
   */
  renderImage: _propTypes2.default.func,

  /**
   * An optional hyperlink URL
   */
  href: _propTypes2.default.string,

  /**
   * An onClick event handler
   */
  onClick: _propTypes2.default.func,

  /**
   * Should the icon accompanying an onClick handler be a cross (i.e. close button)?
   */
  hasCloseButton: _propTypes2.default.bool,

  /**
   * Should the hyperlink be opened in a new window?
   */
  shouldOpenInNewWindow: _propTypes2.default.bool,

  /**
   * Is the ServiceBanner being rendered in a row style on mobile (i.e. without rounded corners)
   */
  isMobileRow: _propTypes2.default.bool

}, _SpacerElement2.default.propTypes);

ServiceBanner.defaultProps = _extends({
  title: undefined,
  body: undefined,
  badge: undefined,
  renderImage: undefined,
  href: undefined,
  shouldOpenInNewWindow: false,
  isMobileRow: false,
  onClick: undefined
}, _SpacerElement2.default.defaultProps);

ServiceBanner.placeholderProps = {
  body: 'placeholder',
  renderImage: function renderImage() {
    return undefined;
  },
  title: 'placeholder'
};